/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var CertLicenseIcon24Solid = forwardRef('CertLicenseIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 6a4 4 0 0 1 4-4h12a4 4 0 0 1 4 4v10a4 4 0 0 1-4 4v2.72a.8.8 0 0 1-1.261.654l-1.124-.793a.2.2 0 0 0-.23 0l-1.124.793A.8.8 0 0 1 13 22.721V20H6a4 4 0 0 1-4-4V6Zm4 .75A.75.75 0 0 1 6.75 6h10.5a.75.75 0 0 1 0 1.5H6.75A.75.75 0 0 1 6 6.75ZM8.5 9.5a.75.75 0 0 0 0 1.5h7a.75.75 0 0 0 0-1.5h-7Zm9.75 6a2.75 2.75 0 1 1-5.5 0 2.75 2.75 0 0 1 5.5 0Z" })));
});
